export default __webpack_public_path__ + "static/media/register.32bb3e5e.svg";